// The bar takes payment for an order the server has just priced (Oct 2026). The server prices
// it with the offers running now and the menu as it is now; the cart is the till's own sum of
// the prices it loaded. When the two differ, the server's figure is the bill: the bar shows it
// and asks again, rather than take, and give change on, a figure the order doesn't have.

/** The server's `{total, tax}` when it differs from the cart's sum, else null. */
export function repriced(order, cartSubtotal) {
  if (!order || order.total == null) return null;
  const pence = (x) => Math.round(Number(x || 0) * 100);
  if (pence(order.total) === pence(cartSubtotal)) return null;
  return { total: Number(order.total), tax: Number(order.tax || 0) };
}
